import { HttpContextToken } from '@angular/common/http';

/** Marca una request que muestra su propio progreso (ej. subida de archivos) y no debe prender el overlay global. */
export const SKIP_GLOBAL_LOADING = new HttpContextToken<boolean>(() => false);

/** Marca una request de fondo que reintenta sola (ej. el polling de la sesión): si no llega al servidor, no avisa 'connection-lost'. */
export const SKIP_CONNECTION_LOST_NOTICE = new HttpContextToken<boolean>(() => false);
